module.exports = __webpack_public_path__ + "static/media/be-best.ef247d7d.jpg";